
























import Vue, { PropType } from "vue"
import PSimilarUserProfileCassetteList from "./local/PSimilarUserProfileCassetteList.vue"
import PPlainDetail from "./local/PPlainDetail.vue"
import PBottomFloatingButtonGroup from "./local/forCorporation/PBottomFloatingButtonGroup.vue"
import PSubscriptionGuidanceForScoutModal from "~/components/custom/scout/PSubscriptionGuidanceForScoutModal.vue"
import Container from "~/components/guideline/frame/Container.vue"
import { ParticularWriteAcl } from "~/config/acl/accessControlList"
import {
  similarUserProfilesGetter,
  SimilarUserProfile,
} from "~/uiLogics/similarUserProfilesGetter"
import { BackendApi } from "~/backendApis"
import {
  UserProfileSearchResultView,
  ScoutDetailView,
} from "~/backendApis/viewModel"

interface DataType {
  isVisibleSubscriptionGuidanceModal: boolean
  isVisibleScoutThanksModal: boolean
  similarUserProfiles: SimilarUserProfile[]
  scout: ScoutDetailView | null
}

export default Vue.extend({
  components: {
    Container,
    PPlainDetail,
    PSimilarUserProfileCassetteList,
    PBottomFloatingButtonGroup,
    PSubscriptionGuidanceForScoutModal,
  },
  props: {
    /**
     * 表示するプロフィール
     */
    userProfile: {
      type: Object as PropType<UserProfileSearchResultView>,
      required: true,
    },
  },
  data(): DataType {
    return {
      isVisibleSubscriptionGuidanceModal: false,
      isVisibleScoutThanksModal: false,
      similarUserProfiles: [],
      scout: null,
    }
  },
  computed: {
    isAbleToScoutToUser(): boolean {
      return this.$clAuth.hasPermission(ParticularWriteAcl.USER_SCOUT)
    },
    isFavorited(): boolean {
      return this.$clStores.corporationSideFavoriteUserList.getters.isFavorited(
        this.userProfile.universalUid
      )
    },
  },
  created() {
    this.initializePage()
  },
  methods: {
    async initializePage() {
      this.initializeSimilarUserProfiles()
      await this.initializeScout()
      this.$clStores.corporationSideFavoriteUserList.actions.refreshList()

      // 企業アカウントの場合は閲覧履歴として記録
      BackendApi.CorporationMember.userProfile.write.createProfileViewedByCorporationEvent(
        {
          universalCorporationIdOfViewer: this.$clAuth.corporationIdOrFail,
          universalUidOfProfileOwner: this.userProfile.universalUid,
        }
      )

      if (String(this.$route.query.openScoutModal) === "1") {
        this.openScoutModalIfQualified()
      }
    },
    async initializeSimilarUserProfiles() {
      if (this.userProfile.mainSmallJobCategoryId) {
        const excludedUniversalUids = [this.userProfile.universalUid]
        this.similarUserProfiles = await similarUserProfilesGetter().getByLargeJobCategoryId(
          this.userProfile.mainSmallJobCategoryId,
          excludedUniversalUids
        )
      }
    },
    async initializeScout() {
      const scout = await new BackendApi.CorporationMember.Matching.GetScoutDetailLatestReadRequest(
        {
          universalCorporationId: this.$clAuth.corporationIdOrFail,
          universalUid: this.userProfile.universalUid,
        }
      ).get()
      this.scout = scout
    },
    toggleFavoriteStatus() {
      this.$clStores.corporationSideFavoriteUserList.actions.toggleFavoriteStatus(
        this.userProfile.universalUid
      )
    },
    openSubscriptionGuidanceModal() {
      this.isVisibleSubscriptionGuidanceModal = true
    },
    closeSubscriptionGuidanceModal() {
      this.isVisibleSubscriptionGuidanceModal = false
    },
    async openScoutModalIfQualified() {
      if (!this.isAbleToScoutToUser) {
        this.openSubscriptionGuidanceModal()
        return
      }

      // 相手とのグループが存在する場合はそのチャットグループの詳細ページに遷移
      if (this.scout !== null && this.scout.chatGroupId !== undefined) {
        this.$nuxt.$router.push({
          path: `/corporation/chats/${this.scout.chatGroupId}`,
        })
        return
      }

      // スカウト件数が制限範囲内か判定
      const limitCount = this.$clAuth.limitCount(ParticularWriteAcl.USER_SCOUT)
      const scoutCount = await this.countScouts()
      if (limitCount && limitCount <= scoutCount) {
        // 制限を超えていた場合、有料プランへ誘導
        this.openSubscriptionGuidanceModal()
        return
      }
      this.$nuxt.$router.push({
        path: `/corporation/scouts/create/${this.userProfile.universalUid}`,
      })
    },
    async countScouts(daysOfAggregationPeriod?: number): Promise<number> {
      return (
        await BackendApi.CorporationMember.Matching.read.countScouts({
          universalCorporationId: this.$clAuth.corporationIdOrFail,
          daysOfAggregationPeriod,
        })
      ).numberOfScouts
    },
  },
})
